import React, { useState } from 'react';
import { BrainIcon } from 'lucide-react';

const DesarrolloMotrizLenguaje = ({ formData, setFormData, handleInputChange }) => {
    const [otroIdioma, setOtroIdioma] = React.useState('');
    const [mostrarOtroIdiomaInput, setMostrarOtroIdiomaInput] = React.useState(false);
    const [otroConQuienDuerme, setOtroConQuienDuerme] = React.useState('');
    const [mostrarOtroConQuienDuermeInput, setMostrarOtroConQuienDuermeInput] = React.useState(false);

    // Efecto para inicializar mostrarOtroIdiomaInput si formData.idiomaCasa no está en las opciones predefinidas
    React.useEffect(() => {
        const opcionesPredeterminadas = ["Español", "Inglés", "Francés", "Alemán", "Mandarín", ""]; // "" handles empty string
        if (formData.idiomaCasa && !opcionesPredeterminadas.includes(formData.idiomaCasa)) {
            setMostrarOtroIdiomaInput(true);
            setOtroIdioma(formData.idiomaCasa);
        } else {
            setMostrarOtroIdiomaInput(false);
            if (opcionesPredeterminadas.includes(formData.idiomaCasa) || !formData.idiomaCasa) {
                 setOtroIdioma('');
            }
        }
    }, [formData.idiomaCasa]);

    // Efecto para inicializar mostrarOtroConQuienDuermeInput si formData.habitosSuenoConQuien no está en las opciones predefinidas
    React.useEffect(() => {
        const opcionesConQuienDuerme = ["Padre", "Madre", "Padre y Madre", "Hermanos", "Abuelos", ""]; // "" handles empty string
        if (formData.habitosSuenoConQuien && !opcionesConQuienDuerme.includes(formData.habitosSuenoConQuien)) {
            setMostrarOtroConQuienDuermeInput(true);
            setOtroConQuienDuerme(formData.habitosSuenoConQuien);
        } else {
            setMostrarOtroConQuienDuermeInput(false);
            if (opcionesConQuienDuerme.includes(formData.habitosSuenoConQuien) || !formData.habitosSuenoConQuien) {
                setOtroConQuienDuerme('');
            }
        }
    }, [formData.habitosSuenoConQuien]);
    const toggleCheckboxField = (fieldName) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: !prev[fieldName]
        }));
    };

    // Función para validar números enteros positivos
    const handleNumberInputChange = (e) => {
        const { name, value } = e.target;
        // Solo permitir números enteros positivos
        if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
            handleInputChange({
                target: {
                    name,
                    value: value === '' ? '' : parseInt(value)
                }
            });
        }
    };

    const inputClasses = `w-full p-1.5 rounded-lg border border-gray-300 bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`;

    return (
        <div className="bg-white rounded-lg p-4 max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2 flex items-center">
                <BrainIcon className="mr-2 text-blue-500 w-4 h-4" />
                Desarrollo Motriz y Lenguaje
            </h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        ¿Su hijo/a gateó?
                    </label>
                    <div className="flex items-center space-x-4">
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="gateo"
                                checked={formData.gateo}
                                onChange={() => toggleCheckboxField('gateo')}
                                className="form-radio text-indigo-600"
                            /> <span className="ml-2 text-sm">Sí</span>
                        </label>
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="gateo"
                                checked={!formData.gateo}
                                onChange={() => toggleCheckboxField('gateo')}
                                className="form-radio text-indigo-600"
                            /> <span className="ml-2 text-sm">No</span>
                        </label>
                    </div>
                    {formData.gateo && (
                        <input
                            type="number"
                            name="edadInicioGateo"
                            placeholder="Edad de inicio (meses)"
                            value={formData.edadInicioGateo}
                            onChange={handleNumberInputChange}
                            min="0"
                            onKeyDown={(e) => {
                                if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                    e.preventDefault();
                                }
                            }}
                            className={inputClasses}
                        />
                    )}
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Edad en que inició a caminar (meses)
                    </label>
                    <input
                        type="number"
                        name="edadInicioCaminar"
                        placeholder="Meses en que inició a caminar"
                        value={formData.edadInicioCaminar}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={inputClasses}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Tipo de lactancia
                    </label>
                    <select
                        name="tipoLactancia"
                        value={formData.tipoLactancia}
                        onChange={handleInputChange}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="Materna">Materna</option>
                        <option value="Artificial">Artificial</option>
                        <option value="Mixta">Mixta</option>
                    </select>
                    <input
                        type="number"
                        name="edadFinLactancia"
                        placeholder="Edad fin lactancia (meses)"
                        value={formData.edadFinLactancia}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={`mt-2 ${inputClasses}`}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Mano dominante
                    </label>
                    <select
                        name="manoDominante"
                        value={formData.manoDominante}
                        onChange={handleInputChange}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="Izquierda">Izquierda</option>
                        <option value="Derecha">Derecha</option>
                    </select>
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Control de esfínteres
                    </label>
                    <div className="grid grid-cols-2 gap-2">
                        <div>
                            <label className="block text-xs mb-1">Diurno</label>
                            <div className="flex items-center space-x-4">
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="controlEsfinteresDiurno"
                                        checked={formData.controlEsfinteresDiurno}
                                        onChange={() => toggleCheckboxField('controlEsfinteresDiurno')}
                                        className="form-radio text-indigo-600"
                                    /> <span className="ml-2 text-sm">Sí</span>
                                </label>
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="controlEsfinteresDiurno"
                                        checked={!formData.controlEsfinteresDiurno}
                                        onChange={() => toggleCheckboxField('controlEsfinteresDiurno')}
                                        className="form-radio text-indigo-600"
                                    /> <span className="ml-2 text-sm">No</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs mb-1">Nocturno</label>
                            <div className="flex items-center space-x-4">
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="controlEsfinteresNocturno"
                                        checked={formData.controlEsfinteresNocturno}
                                        onChange={() => toggleCheckboxField('controlEsfinteresNocturno')}
                                        className="form-radio text-indigo-600"
                                    /> <span className="ml-2 text-sm">Sí</span>
                                </label>
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="controlEsfinteresNocturno"
                                        checked={!formData.controlEsfinteresNocturno}
                                        onChange={() => toggleCheckboxField('controlEsfinteresNocturno')}
                                        className="form-radio text-indigo-600"
                                    /> <span className="ml-2 text-sm">No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    {(formData.controlEsfinteresDiurno && formData.controlEsfinteresNocturno) && (
                        <input
                            type="number"
                            name="edadControlEsfinteres"
                            placeholder="Edad control total (meses)"
                            value={formData.edadControlEsfinteres}
                            onChange={handleNumberInputChange}
                            min="0"
                            onKeyDown={(e) => {
                                if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                    e.preventDefault();
                                }
                            }}
                            className={`mt-2 ${inputClasses}`}
                        />
                    )}
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Observaciones control esfínteres
                    </label>
                    <textarea
                        name="observacionesControlEsfinteres"
                        placeholder="Información adicional del proceso"
                        value={formData.observacionesControlEsfinteres}
                        onChange={handleInputChange}
                        className={inputClasses}
                        rows="2"
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Idioma que se habla en casa
                    </label>
                    <select
                        name="idiomaCasaSelector"
                        value={mostrarOtroIdiomaInput ? 'Otro' : formData.idiomaCasa}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === 'Otro') {
                                setMostrarOtroIdiomaInput(true);
                                // No actualizamos formData.idiomaCasa aquí directamente
                                // se hará cuando el input de 'otroIdioma' cambie
                            } else {
                                setMostrarOtroIdiomaInput(false);
                                handleInputChange({ target: { name: 'idiomaCasa', value } });
                            }
                        }}
                        className={inputClasses}
                    >
                        <option value="">Seleccione un idioma</option>
                        <option value="Español">Español</option>
                        <option value="Inglés">Inglés</option>
                        <option value="Francés">Francés</option>
                        <option value="Alemán">Alemán</option>
                        <option value="Mandarín">Mandarín</option>
                        <option value="Otro">Otro</option>
                    </select>
                    {mostrarOtroIdiomaInput && (
                        <input
                            type="text"
                            name="idiomaCasaOtro"
                            placeholder="Especifique el idioma"
                            value={otroIdioma}
                            onChange={(e) => {
                                setOtroIdioma(e.target.value);
                                handleInputChange({ target: { name: 'idiomaCasa', value: e.target.value } });
                            }}
                            className={`mt-2 ${inputClasses}`}
                        />
                    )}
                </div>



                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Edad de balbuceo (meses)
                    </label>
                    <input
                        type="number"
                        name="edadBalbuceo"
                        placeholder="Meses en que inició a balbucear"
                        value={formData.edadBalbuceo}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={inputClasses}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Edad palabras sueltas (meses)
                    </label>
                    <input
                        type="number"
                        name="edadPalabrasSueltas"
                        placeholder="Meses en que inició a hablar palabras sueltas"
                        value={formData.edadPalabrasSueltas}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={inputClasses}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Edad de hablar (meses)
                    </label>
                    <input
                        type="number"
                        name="edadHablar"
                        placeholder="Meses en que inició a hablar"
                        value={formData.edadHablar}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={inputClasses}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        ¿Ha recibido terapia de lenguaje?
                    </label>
                    <div className="flex items-center space-x-4">
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="terapiaLenguaje"
                                checked={formData.terapiaLenguaje}
                                onChange={() => toggleCheckboxField('terapiaLenguaje')}
                                className="form-radio text-indigo-600"
                            /> <span className="ml-2 text-sm">Sí</span>
                        </label>
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="terapiaLenguaje"
                                checked={!formData.terapiaLenguaje}
                                onChange={() => toggleCheckboxField('terapiaLenguaje')}
                                className="form-radio text-indigo-600"
                            /> <span className="ml-2 text-sm">No</span>
                        </label>
                    </div>
                    {formData.terapiaLenguaje && (
                        <textarea
                            name="terapiaLenguajeDetalle"
                            placeholder="Especifique el tiempo y la razón"
                            value={formData.terapiaLenguajeDetalle}
                            onChange={handleInputChange}
                            className={`mt-2 ${inputClasses}`}
                            rows="2"
                        />
                    )}
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        ¿Con quién duerme?
                    </label>
                    <select
                        name="habitosSuenoConQuienSelector"
                        value={mostrarOtroConQuienDuermeInput ? 'Otros' : formData.habitosSuenoConQuien}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === 'Otros') {
                                setMostrarOtroConQuienDuermeInput(true);
                            } else {
                                setMostrarOtroConQuienDuermeInput(false);
                                handleInputChange({ target: { name: 'habitosSuenoConQuien', value } });
                            }
                        }}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="Padre">Padre</option>
                        <option value="Madre">Madre</option>
                        <option value="Padre y Madre">Padre y Madre</option>
                        <option value="Hermanos">Hermanos</option>
                        <option value="Abuelos">Abuelos</option>
                        <option value="Otros">Otros</option>
                    </select>
                    {mostrarOtroConQuienDuermeInput && (
                        <input
                            type="text"
                            name="habitosSuenoConQuienOtro"
                            placeholder="Especifique con quién duerme"
                            value={otroConQuienDuerme}
                            onChange={(e) => {
                                setOtroConQuienDuerme(e.target.value);
                                handleInputChange({ target: { name: 'habitosSuenoConQuien', value: e.target.value } });
                            }}
                            className={`mt-2 ${inputClasses}`}
                        />
                    )}
                </div>



                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Edad inicio dormir solo (meses)
                    </label>
                    <input
                        type="number"
                        name="habitosSuenoEdad"
                        value={formData.habitosSuenoEdad}
                        onChange={handleNumberInputChange}
                        min="0"
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === '-' || e.key === 'e') {
                                e.preventDefault();
                            }
                        }}
                        className={inputClasses}
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Dificultades de sueño
                    </label>
                    <textarea
                        name="dificultadesSueno"
                        placeholder="Dificultades en esta área"
                        value={formData.dificultadesSueno}
                        onChange={handleInputChange}
                        className={inputClasses}
                        rows="2"
                    />
                </div>
            </div>
        </div>
    );
};

export default DesarrolloMotrizLenguaje;
